import React from 'react';
import { Box } from '@mui/material';

const Layout = ({ children }) => {
  return (
    <Box sx={{ 
      px: { xs: 0, sm: 3 }, // Horizontal padding
      pt: { xs: '70px', sm: '85px' }, // Top padding to compensate for fixed header
      pb: 0, // Zero bottom padding
      height: '100%',
      overflow: 'visible',
      position: 'relative',
    }}>
      {children}
    </Box>
  );
};

export default Layout; 